(function ($) {
  Drupal.behaviors.basicReadMoreV1 = {
    attach: function (context) {
      var $content = $('.basic-read-more', context);
      var $wrapper = $('.js-basic-read-more-main-content', $content);
      var $mainContent = $('.js-basic-read-more-content', $content);
      var $readMoreSection = $('.js-basic-read-more-icon', $content);
      var $iconPlus = $('.basic-read-more__link--plus', $readMoreSection);
      var $iconCollapse = $('.basic-read-more__link--collapse', $readMoreSection);
      var $totalHeight = $mainContent.height();
      var $initHeight = 125;

      if ($totalHeight > $initHeight) {
        $readMoreSection.removeClass('inactive');
        $wrapper.addClass('active-shadow');
        $wrapper
          .each(function () {
            $.data(this, 'realHeight', $(this).height());
          })
          .css({
            overflow: 'hidden',
            height: $initHeight + 'px'
          });
        $readMoreSection.once().on('click', function () {
          if ($wrapper.hasClass('basic-read-more__main-content--expanded')) {
            $wrapper.animate({ height: $initHeight }, 600);
            $wrapper.removeClass('basic-read-more__main-content--expanded').addClass('active-shadow');
            $iconCollapse.addClass('hidden');
            $iconPlus.removeClass('hidden');
          } else {
            $wrapper.animate({ height: $wrapper.data('realHeight') }, 600);
            $wrapper.addClass('basic-read-more__main-content--expanded').removeClass('active-shadow');
            $iconPlus.addClass('hidden');
            $iconCollapse.removeClass('hidden');
          }
        });
      }
    }
  };
})(jQuery);
